import { render, staticRenderFns } from "./v-radio.vue?vue&type=template&id=a48a4424&"
import script from "./v-radio.vue?vue&type=script&lang=js&"
export * from "./v-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./v-radio.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports